<template>
  <div>
    <v-container class="pt-0 pb-10">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <v-btn color="primary-dark" @click="$router.push({ name: 'Administration' })" density="compact"
              variant="outlined">
              <v-icon left>mdi-arrow-left</v-icon>
              Retour
            </v-btn>
            <div class="text-h6 mt-2 mb-4">Effectuer un remboursement sur la commande n°{{ commande_refund.uuid }}</div>

            <v-sheet class="pa-2 my-2" border color="grey-lighten-5" elevation="0">
              <div class="font-italic">
                <v-icon icon="mdi-information" color="primary-dark"></v-icon> Vous avez la possibilité d'effectuer un
                remboursement:<br />
                - sur les transactions souhaitées, le remboursement total sur la commande sera donc calculé<br />
                - ou alors sur la commande globale, le total sera donc répartie sur les différentes transactions.
              </div>
            </v-sheet>
            <div class="mt-4">Liste des transactions associées à cette commande :</div>
            <v-sheet v-for="transaction in commande_refund.list_transactions" :key="transaction.id" class="pa-2 my-2"
              border color="grey-lighten-5" elevation="0">
              <div class="font-bold">Transaction n°{{ transaction.uuid }}</div>
              <v-row>
                <v-col>
                  <v-chip variant="elevated" color="white" elevation="0" border>
                    <v-icon v-if="transaction.statut == 'PAID' && transaction.captured" icon="mdi-check"
                      color="green-darken-4"></v-icon>
                    <v-icon v-else icon="mdi-close" color="deep-orange-darken-4"></v-icon>
                    Remboursable
                  </v-chip>
                </v-col>
                <v-col>
                  <div>Total transaction : {{ transaction.prix }}€</div>
                  <div>Total après remboursement : {{ transaction.total_after_refund }}€</div>
                </v-col>
                <v-col v-if="transaction.statut == 'PAID' && transaction.captured">
                  <v-text-field label="Total à rembourser sur cette transaction" type="number"
                    v-model="transaction.amount_to_refund"
                    @update:modelValue="onUpdateTransactionRefund(transaction.uuid)"></v-text-field>
                </v-col>
              </v-row>
            </v-sheet>
            <v-row class="mt-3">
              <v-col md="5">
                <v-text-field label="Frais de remboursement" type="number" append-inner-icon="mdi-currency-eur"
                  v-model="commande_refund.fee_amount"></v-text-field>
              </v-col>
              <v-col md="5">
                <v-autocomplete label="Frais de remboursement payé par" :items="$itemsSelect.refund_fee_payed_by()"
                  v-model="commande_refund.fee_payed_by"></v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="mt-1">
              <v-col md="5">
                <div>Total de la commande : {{ commande_refund.prix_total }}€ (dont {{ commande_refund.taxe }}€ de taxe)
                </div>
                <div>Total remboursable : {{ commande_refund.total_refundable }}€</div>

                <v-text-field class="mt-3" label="Total à rembourser sur la commande" type="number"
                  append-inner-icon="mdi-currency-eur" v-model="commande_refund.amount_to_refund"></v-text-field>
                <div>Total après remboursement : {{ commande_refund.total_after_refund }}€</div>
                <v-btn class="mt-3" color="primary-dark" @click="refund()" variant="tonal">
                  <v-icon left>mdi-cash-refund</v-icon>
                  Effectuer le remboursement
                </v-btn>
              </v-col>
              <v-col> </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Commande_Refund from "@/classes/Refund/Commande_Refund.class.js";
export default {
  data() {
    return {
      commande_refund: new Commande_Refund(),
    };
  },
  methods: {
    onUpdateTransactionRefund(uuid) {
      this.commande_refund.calculate_amount_to_refund(uuid);
    },
    onUpdateCommandeGlobaleRefund() {
      this.commande_refund.calculate_transaction_amount_to_refund();
    },
  },

  async mounted() {

    this.commande_refund.id_commande = this.$route.params.id_commande;
    await this.commande_refund.fetch();
  },
};
</script>

<style lang="scss" scoped></style>